import { IStoredSetting, SeparatorType } from "@store/me/actionTypes";
import { ALGOS_E } from "@constants/Algos";
import { PostRequest } from "./http/BaseRequest";
import { ServerResponse } from "./http/settings";
import { BaseResponse } from "./http/responses/BaseResponse";
import { MINER_STATUSES_E } from "@constants/MinerStatuses";

export interface IPoolSettings {
  hash: ALGOS_E;
  address_1: string;
  login_1: string;
  password_1: string;
  separator_1: SeparatorType;
  address_2: string;
  login_2: string;
  password_2: string;
  separator_2: SeparatorType;
  address_3: string;
  login_3: string;
  password_3: string;
  separator_3: SeparatorType;
}

export interface IPoolCreds {
  address: string;
  login: string;
  password: string;
  separator: SeparatorType;
  status?: MINER_STATUSES_E;
  is_default?: boolean;
  props?: string;
}

export interface IPoolSettingsNew {
  hash: ALGOS_E;
  Pools: IPoolCreds[];
}

export interface Pool extends IPoolSettingsNew {
  id?: number | string;
}

export interface ISummarySettings extends Pool {
  name: string;
}

export class GetAdminSettingsRequest extends PostRequest {
  constructor() {
    super("/admin/miner/settings/list", {});
  }
}

export class GetUserSettingsRequest extends PostRequest {
  constructor() {
    super("/user/miner/settings/list", {});
  }
}

export class DeletePoolSettingsRequest extends PostRequest {
  constructor(id: number) {
    super("/settings/delete", { id });
  }
}

export interface ICurrentSetting {
  readonly Address: string;
  readonly Login: string;
  readonly Password: string;
  readonly Separator: string;
  readonly Props?: string;
}
export interface IGetCurrentSettingsResponseRecord extends BaseResponse {
  Record: ICurrentSetting[];
}
// export class GetCurrentPoolConnection extends PostRequest {
//   constructor(minerid: string) {
//     super("/admin/miner/settings/get", { minerid });
//   }
// }

export class GetCurrentPoolConnection extends PostRequest {
  constructor(id: string) {
    super("/miner/connection/get", { id });
  }
}

export interface CurrentUserSettingsResponse extends ServerResponse {
  Record: IStoredSetting[];
}

export class GetCurrentUserSettings extends PostRequest {
  constructor(userid: string, key: "user_id" | "user_email" = "user_id") {
    // const builder = new W2UiFilterBuilder();
    // builder.setSearch([SearchItem.textIs(key, userid)]);
    // const params = builder.build().stringParams;
    super("/admin/miner/settings/list", { [key]: userid });
  }
}
